<template>
  <v-row
    align="center"
    justify="center"
  >
    <v-col cols="10">
      <v-toolbar
        dark
        color="primary"
      >
        <v-toolbar-title>
          {{ teamSelectTitle }}
        </v-toolbar-title>
      </v-toolbar>
      <ListWithSubtitles
        :items="displayedTeams"
        class="p-0"
        icon="keyboard_arrow_right"
        @dispatch="changeTeam"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ListWithSubtitles from '@/components/shared/content-views/ListWithSubtitles';

export default {
    components: {
        ListWithSubtitles,
    },
    computed: {
        ...mapGetters([
            'teams',
            'hasSelectedTeam',
            'teamIndex',
        ]),
        displayedTeams() {
            const filteredTeams = this.teams.filter(team => team.active);
            return filteredTeams.map(({ id, name, active }) => ({
                title: name,
                id,
                active,
            }));
        },
        teamSelectTitle() {
            return this.hasSelectedTeam
                ? this.$t('teams.switchTeam')
                : this.$t('teams.selectTeam');
        },
    },
    methods: {
        ...mapActions({
            switchTeam: 'switchTeam',
            reloadTeam: 'reloadTeam',
        }),
        async changeTeam(e, index) {
            const selectedTeam = this.displayedTeams[index];
            if (this.teamIndex !== index) {
                this.switchTeam(selectedTeam);
            }
            this.$router.push({ name: 'dashboard' });
        },
    },
};
</script>
